export default {
  get name(): string {
    return 'ExponentErrorRecovery';
  },
  setRecoveryProps(): void {},
};
